// Used by firebase.js to connect the app to firebase
export const firebaseConfig = {
  apiKey: "AIzaSyD-H0WazcMxOxLo90iKMGeQpdaoWxHrRGw",
  authDomain: "artist-tracker-e5cce.firebaseapp.com",
  projectId: "artist-tracker-e5cce",
  storageBucket: "artist-tracker-e5cce.appspot.com",
  messagingSenderId: "405667516642",
  appId: "1:405667516642:web:f291c3b9003bb2c4698ebb"
};

// links lemonsqueezy products to access levels
// using AccessGates and AccessGuards
export const products = {
  93384: {
    display: "Elite",
    checkout: "https://indiestack-dev.lemonsqueezy.com/checkout/buy/adf75e2b-cd9d-4748-90e8-52902f4b5f32",
    access: ['elite', 'starter']
  },
  93383: {
    display: "Starter",
    checkout: "https://indiestack-dev.lemonsqueezy.com/checkout/buy/8364507c-5684-45a5-b1d3-4078108fccec",
    access: ['starter']
  }
}